import { useDateFormat } from '@vueuse/core'
import { toValue } from 'vue'

/**
 * Returns current date in ISO format
 * @returns {string}
 */
export const nowInIsoDate = () => toValue(useDateFormat(new Date(), 'YYYY-MM-DD'))

/**
 * Returns current date and time in ISO format
 * @returns {string}
 */
export const nowInIsoDateTime = () => toValue(useDateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss'))

/**
 * Returns current year
 * @returns {string}
 */
export const thisYear = () => toValue(useDateFormat(new Date(), 'YYYY'))
